module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-20-08-small-395affd8b0f206cacd9bd346df2d1286.png";